import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import gotchiIcon from '@assets/images/characters/gotchi.png'
import './DefiDatagotchiCallout.scss'

type Props = {
  children: ReactNode
  className?: string
  /** Hide heading icon. */
  hideIcon?: boolean
  /** Override default gotchi icon (e.g. LEO logo). */
  icon?: string
  /** Override default “Défi Datagotchi” title. */
  title?: string
}

/** Standard “Défi Datagotchi” card — pale grey-yellow bg ($datagotchi-callout-bg). */
export function DefiDatagotchiCallout({
  children,
  className,
  hideIcon = false,
  icon = gotchiIcon,
  title,
}: Props) {
  const { t } = useTranslation('Consent')
  const headingTitle = title ?? t('progressDemo.challengeTitle')

  return (
    <div
      className={[
        'DefiDatagotchiCallout',
        hideIcon ? 'DefiDatagotchiCallout--noIcon' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}>
      <div className="DefiDatagotchiCallout-heading">
        {!hideIcon && (
          <img src={icon} alt="" className="DefiDatagotchiCallout-heading-icon" />
        )}
        <h3 className="DefiDatagotchiCallout-heading-title">{headingTitle}</h3>
      </div>
      <div className="DefiDatagotchiCallout-body">{children}</div>
    </div>
  )
}

export default DefiDatagotchiCallout
